import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Typography, Box, Button } from '@mui/material';

const PrivacyPage = () => {
  const { t } = useTranslation();

  const handleClose = () => {
    // Close the page or navigate back
    window.close();  // This will work only if opened as a new window/tab
  };

  return (
    <Container maxWidth="md">
      <Box sx={{ py: 3 }}>
        <Typography variant="h4" gutterBottom>
          {t('footer.privacy')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.intro')}
        </Typography>

        <Typography variant="h6" gutterBottom>
          {t('footer.section1.title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.personal_data.title')}: {t('footer.personal_data.description')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.usage_data.title')}: {t('footer.usage_data.description')}
        </Typography>

        <Typography variant="h6" gutterBottom>
          {t('footer.section2.title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.usage_purpose1')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.usage_purpose2')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.usage_purpose3')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.usage_purpose4')}
        </Typography>

        <Typography variant="h6" gutterBottom>
          {t('footer.section3.title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.section3.description')}
        </Typography>

        <Typography variant="h6" gutterBottom>
          {t('footer.section4.title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.right1')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.right2')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.right3')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.contact_rights')}
        </Typography>

        <Typography variant="h6" gutterBottom>
          {t('footer.section5.title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.section5.description')}
        </Typography>

        <Typography variant="h6" gutterBottom>
          {t('footer.section6.title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.section6.description')}
        </Typography>

        <Typography variant="h6" gutterBottom>
          {t('footer.section7.title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.section7.description')}
        </Typography>

        <Typography variant="h6" gutterBottom>
          {t('footer.section8.title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.section8.description')}
        </Typography>

      
        
      </Box>
    </Container>
  );
};

export default PrivacyPage;
